<template>
  <div id="header">
    <nav class="navbar navbar-expand-xl navbar-light bg-white">
      <div class="container-fluid">
        <!-- Logo -->
        <router-link to="/" class="navbar-brand">
          <img class="w-100" src="./../assets/images/logo_1.png">
        </router-link>

        <!-- Mobile button -->
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- ✅ 非 /app：保持你現在一模一樣 -->
        <div
          v-if="!isInApp"
          ref="menuCollapse"
          class="collapse navbar-collapse row"
          id="navbarContent"
        >
          <!-- Head -->
          <ul class="navbar-nav mx-auto col-xl-7 col-lg-12">
            <li
              class="nav-item w-25 h4"
              v-for="(head, i) in headers"
              :key="head.key"
            >
              <router-link
                class="nav-link px-4 text-purple"
                :class="{ 'border-left': i != 0 }"
                :to="head.path"
              >
                {{ $t(head.key) }}
              </router-link>
            </li>
          </ul>

          <!-- Language -->
          <ul id="lan-bar" class="mt-auto mb-auto col-xl-3 col-lg-12">
            <li
              v-for="(locale, i) in locales"
              :key="locale"
              @click="switchLocale(locale)"
            >
              <span
                role="button"
                class="px-1 text-purple"
                :class="{ 'border-left': i != 0 }"
              >
                {{ $t(locale) }}
              </span>
            </li>
          </ul>
        </div>

        <!-- ✅ /app：隱藏 tabs，只顯示置中的 Member + 右側登出(在語言之前) -->
        <div
          v-else
          ref="menuCollapse"
          class="collapse navbar-collapse row app-mode"
          id="navbarContent"
        >
          <!-- 中央：Member（多語言） -->
          <div class="app-center col-xl-7 col-lg-12">
            <div class="app-title text-purple">
              {{ $t('Member') }}
            </div>
          </div>

          <!-- 右側：登出在前、語言在後（語言不壓縮） -->
          <div class="app-right col-xl-3 col-lg-12 mt-auto mb-auto">
            <div class="app-right-inner">
              <button
                v-if="showLogout"
                class="btn btn-outline-danger btn-sm"
                @click="onLogout"
              >
                {{ $t('common.logout') || '登出' }}
              </button>

              <div class="app-lang">
                <span
                  v-for="(locale, i) in locales"
                  :key="locale"
                  role="button"
                  class="px-1 text-purple"
                  :class="{ 'border-left': i != 0 }"
                  @click="switchLocale(locale)"
                >
                  {{ $t(locale) }}
                </span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </nav>
  </div>
</template>

<script>
import { Collapse } from 'bootstrap'
import { supabase } from '@/lib/supabase'

export default {
  name: 'Header',
  data () {
    return {
      locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(','),
      headers: [
        { key: 'home', path: '/' },
        { key: 'about', path: '/about' },
        { key: 'Member', path: '/member' }
        // { key: 'contact', path: '/contact' }
      ],
      hasSession: false,
      authSub: null
    }
  },

  computed: {
    isInApp () {
      return this.$route.path.startsWith('/app')
    },
    showLogout () {
      return this.hasSession && this.isInApp
    }
  },

  methods: {
    switchLocale (locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale
      }
    },

    async onLogout () {
      await supabase.auth.signOut()
      this.hasSession = false
      this.$router.replace('/member')
    }
  },

  async mounted () {
    // eslint-disable-next-line no-new
    new Collapse(this.$refs.menuCollapse, { toggle: false })

    // 初始 session
    const { data } = await supabase.auth.getSession()
    this.hasSession = !!data?.session

    // 監聽登入 / 登出
    this.authSub = supabase.auth.onAuthStateChange((_event, session) => {
      this.hasSession = !!session
    }).data.subscription
  },

  beforeUnmount () {
    this.authSub?.unsubscribe?.()
  }
}
</script>

<style lang="scss">
@import '@/scss/theme.scss';

/* ✅ 你原本的樣式：完全保留不動 */
#header {
  @include media-pc {
    margin-left: 15rem;
    margin-right: 15rem;
  }
  @include media-lgnb {
    margin-left: 2rem;
    margin-right: 2rem;
  }
  @include media-nb {
    margin-left: 0;
    margin-right: 0;
  }

  .navbar-brand {
    @include media-mobile {
      width: 50%;
    }
  }

  .border-left {
    border-left: 1px solid $purple !important;
  }

  ul {
    display: flex;
    list-style: none;

    @include media-pc {
      flex-direction: row;
    }

    a {
      color: $dark-purple !important;
    }
  }

  .navbar-nav {
    @include media-nb {
      flex-direction: column;
      padding-left: 40px;

      .border-right {
        border-right: none !important;
      }
    }

    .nav-item {
      text-align: center;

      @include media-nb {
        text-align: left;

        .border-left {
          border-left: none !important;
        }
      }

      @include media-mobile {
        width: 100% !important;
      }
    }
  }

  #lan-bar {
    justify-content: flex-end;

    @include media-nb {
      padding-top: 1rem;
      padding-left: 40px;
      justify-content: normal;
    }
  }

  /* =========================================================
     ✅ 只有 /app 才用到的補丁：不影響非 /app
     ========================================================= */

  .app-mode {
    align-items: center;
  }

  .app-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .app-title {
    font-weight: 700;
    font-size: 1.35rem;
    letter-spacing: 0.04em;
    text-align: center;
  }

  .app-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .app-right-inner {
    display: inline-flex;
    align-items: center;
    gap: 0.6rem;
    flex-wrap: nowrap;
  }

  .app-lang {
    display: inline-flex;
    align-items: center;
    flex-wrap: nowrap;   /* ✅ 不換行 */
    white-space: nowrap; /* ✅ 不壓縮拆字 */
  }

  /* 手機 collapse 展開時，保持跟你原本一致：靠左、加 padding */
  @include media-nb {
    .app-center {
      justify-content: flex-start;
      padding-left: 40px;
      padding-top: 0.75rem;
    }

    .app-right {
      justify-content: flex-start;
      padding-left: 40px;
      padding-top: 1rem;
    }
  }
}
</style>
